import React, { useMemo, useState, useEffect, forwardRef,
  useImperativeHandle } from "react";
import { useTranslation } from 'react-i18next';
import {
  View,
  Text,
  StyleSheet,
} from "react-native";
import { useSessionStore } from "../../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../../state/src/useSessionStore";
import  FloatingTextInputComponent from "../../../common/FloatingTextInputComponent";
import Colors from "../../../../../constants/colors";
import { ComponentStyles } from "../../../../../constants/componentStyles";

type Props = {
  onValidationChange?: (isValid: boolean) => void;
  onReferenceNumberChange?: (referenceNumber: string) => void;
};

export interface ReceiverReferenceNumberStepHandle {
  submit: () => Promise<boolean>;
}

const ReceiverReferenceNumberStep = forwardRef<ReceiverReferenceNumberStepHandle, Props>(({ onValidationChange, onReferenceNumberChange }: Props, ref) => {
  const { t, i18n } = useTranslation();
  const storedRefForLookup = useSessionStore((s: SessionState) => (s as any).senderPhotoIdNumber as string | null | undefined);
  const [idNumber, setIdNumber] = useState(
    () => String((useSessionStore.getState() as any).senderPhotoIdNumber ?? "")
  );
  const [errors, setErrors] = useState({
        idNumber: "",
  });
  const isReceiver = useSessionStore((s: SessionState) => (s as any).isReceiver);
    console.log('isReceiver==>', isReceiver)
  const selectedIdTypeLabel = useSessionStore((s: SessionState) => (s as any).selectedIdTypeLabel);
  const setSenderPhotoIdNumber = useSessionStore((s: SessionState) => (s as any).setSenderPhotoIdNumber);

  useEffect(() => {
    setIdNumber(String(storedRefForLookup ?? ""));
  }, [storedRefForLookup]);

  const isValid = idNumber != "" ;
      
  useEffect(() => {
    if (onValidationChange) {
      onValidationChange(isValid);
    }
  }, [isValid, onValidationChange]);

 // expose validate function
  useImperativeHandle(ref, () => ({
    submit: async () => {
      const newErrors = {
        idNumber: idNumber.trim() ? "" : t("ERROR_REFERENCE_NUMBER_IS_REQUIRED"),
      };
      setErrors(newErrors);
    
      // if any error string is non-empty
      const isValid = !Object.values(newErrors).some(Boolean);
      return isValid;
    },
  }));

  const handleManualInput = async (text: string) => {
    setIdNumber(text);
    setSenderPhotoIdNumber(text);
    // try { onReferenceNumberChange?.(text); } catch {}
    console.log('onReferenceNumberChange==>', text)
    if (errors.idNumber) setErrors({ ...errors, idNumber: "" });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{t("LOOK_UP_TRANSFER")}</Text>
      <Text style={styles.subtitle}>{t("LOOK_UP_SUBTITLE")}</Text>
      <FloatingTextInputComponent
        testID="receiverReferenceNumber"
        label={t("REFERENCE_NUMBER")}
        value={idNumber}
        isAutoFocus={true}
        onChangeText={handleManualInput}
        keyboardType={"default"}
        maxLength={8}
        errorText={errors.idNumber}
        onClearError={() => setErrors((prev) => ({ ...prev, idNumber: "" }))}
      />
      <Text style={[styles.subtitle, styles.sampleText]}
        testID="referenceSample" >{t("REFERENCE_SAMPLE")}
      </Text>
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 24,
    backgroundColor: Colors.white
  },
  title: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.titleFont,
    fontWeight: '500', 
    color: Colors.titleTextColor,
    lineHeight: 34,
    marginBottom: 8
  },
  subtitle: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.subTitleFont,
    fontWeight: '400',
    lineHeight: 24,
    color: Colors.subTitleColor,
    // paddingRight: 60,
    marginBottom: 41
  },
  sampleText: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 20,
    color: Colors.subTitleColor,
    marginBottom: 300
  },
  modalOverlay: {
    flex: 1,
    justifyContent: "flex-end",
    backgroundColor: "rgba(0,0,0,0.4)",
  },
  bottomSheet: {
    backgroundColor: "#fff",
    padding: 20,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
  },
  modalTitle: { fontSize: 18, fontWeight: "700", marginBottom: 10 },
  modalText: { fontSize: 15, color: "#555" },
  modalDOB: {
    fontSize: 18,
    fontWeight: "600",
    marginTop: 10,
    marginBottom: 20,
    textAlign: "center",
  },
  confirmBtn: {
    backgroundColor: "#000",
    padding: 14,
    borderRadius: 8,
    alignItems: "center",
  },
  confirmText: { color: "#fff", fontWeight: "600", fontSize: 16 },
  cancelBtn: { marginTop: 10, alignItems: "center" },
  cancelText: { fontSize: 15, color: "#666" },
});

export default ReceiverReferenceNumberStep;